import { z } from 'zod';

/**
 * An administrator's own account, as My Profile edits it.
 *
 * Mirrors `updateMyAccountSchema` in the backend's `auth.validation.ts` — the
 * server is the authority, these rules only save a round trip. Whether the
 * current password is needed depends on what changed, so that rule is the
 * page's and the server's, not this schema's.
 */

const MOBILE_PATTERN = /^[6-9]\d{9}$/;

/** One character is enough — an initial often is ("Ramesh K"). */
const namePart = (label: string) =>
  z.string().trim().min(1, `Enter your ${label}`).max(80, `Your ${label} is too long`);

export const myAccountSchema = z.object({
  firstName: namePart('first name'),
  lastName: namePart('last name'),
  email: z.string().trim().min(1, 'Enter your email address').email('Enter a valid email address').max(150, 'That address is too long'),
  mobile: z
    .string()
    .trim()
    .transform((value) => value.replace(/[\s-]/g, '').replace(/^(\+91|0)/, ''))
    .refine((value) => value === '' || MOBILE_PATTERN.test(value), 'Enter a valid 10-digit mobile number'),
  currentPassword: z.string(),
});

export type MyAccountFormValues = z.input<typeof myAccountSchema>;

/** What `PATCH /auth/me` takes. */
export interface MyAccountPayload {
  firstName: string;
  lastName: string;
  email: string;
  /** Blank removes it. */
  mobile: string;
  currentPassword?: string;
}
